import { checkForVaiControllerTransactionError } from 'errors';
import type { TransactionReceipt } from 'web3-core';
import { VaiController, UmiVault } from 'types/contracts';

export interface SetSyndicateRateL2Input {
  umiControllerContract: UmiVault;
  fromAccountAddress: string;
  amountWei: string;
}

export type SetSyndicateRateL2Output = TransactionReceipt;

const setSyndicateRateL2 = async ({
                          umiControllerContract,
  fromAccountAddress,
  amountWei,
}: SetSyndicateRateL2Input): Promise<SetSyndicateRateL2Output> => {
  const resp = await umiControllerContract.methods
    .setSyndicateRateL2(amountWei)
    .send({ from: fromAccountAddress });
  return checkForVaiControllerTransactionError(resp);
};

export default setSyndicateRateL2;
